import { Box, Tab, Tabs, useTheme } from '@mui/material';
import React, { SyntheticEvent } from 'react';
import { AIStore } from 'services/store/ai';

type PropTypes = {
  data: AIStore['infoGuide'];
  gridArea: string;
  children?: React.ReactNode;
  index: number;
  value: number;
  handleChange: (event: SyntheticEvent<Element, Event>, value: number) => void;
};

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const GuideSideBar = ({ data, gridArea, value, handleChange }: PropTypes) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        gridArea,
        bgcolor: 'background.paper',
        padding: theme.spacing(2),
        borderTopLeftRadius: theme.spacing(1),
        borderBottomLeftRadius: theme.spacing(1),
      }}
    >
      <Tabs
        orientation="vertical"
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical menu"
        TabIndicatorProps={{
          sx: { left: 0 },
        }}
        sx={{
          '& button': { borderRadius: 0 },
          '& button:hover': {
            backgroundColor: theme.palette.grey[800],
          },
          '& button.Mui-selected': {
            backgroundColor: theme.palette.grey[800],
            color: theme.palette.grey[50],
          },
        }}
      >
        {data?.map((article) => (
          <Tab
            key={article.index}
            label={article.title}
            {...a11yProps(article.index)}
            sx={{ alignItems: 'flex-start' }}
          />
        ))}
      </Tabs>
    </Box>
  );
};
export default GuideSideBar;
